// @flow

export const SECRET_PASSWORD = '********'
